import React from 'react';
import { motion } from 'framer-motion';
import { Heart, ArrowRight } from 'lucide-react';
import { usePricing } from '../hooks/usePricing';
export function Footer() {
  const checkoutUrl = 'https://kreanacrochet.com/cart/add?id=52738305032303&quantity=1';
  const {
    formattedPrice,
    isLoading
  } = usePricing();
  return <footer className="bg-chocolate text-white/80" data-id="element-112">
      {/* Final CTA with product image */}
      <div className="py-10 md:py-16 border-b border-white/10" data-id="element-113">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-114">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-115">
            <p className="font-heading text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-116">
              ¿Lista para tejer a tu mascota?
            </p>
            <p className="text-white/60 mb-10 text-sm max-w-md mx-auto" data-id="element-117">
              Tu compañero peludo merece ser inmortalizado. Empieza hoy con la
              colección completa.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} className="mb-10" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/8VPmE57bCjoWcdR4zzicK2/20260225_1731_Image_Generation_simple_compose_01kjb7zbkpetat25nqp9xr0xsh_(1).png" alt="Colección completa: +60 Patrones Amigurumis de Mascotas con todos los bonos" className="w-full max-w-2xl mx-auto rounded-xl shadow-2xl" data-id="element-119" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-120">
            <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="btn-pulse inline-flex items-center gap-2 px-10 py-4 bg-copper text-white rounded-full font-bold text-lg hover:bg-copper/90 transition-colors shadow-lg" data-id="element-121">
              Quiero Mi Ebook — {isLoading ? '...' : formattedPrice}
              <ArrowRight size={18} data-id="element-122" />
            </a>
          </motion.div>
        </div>
      </div>

      {/* Footer links */}
      <div className="py-10" data-id="element-123">
        <div className="max-w-5xl mx-auto px-4" data-id="element-124">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-125">
            <div className="text-center md:text-left" data-id="element-126">
              <div className="flex items-center justify-center md:justify-start gap-2 mb-2" data-id="element-127">
                <Heart size={14} className="text-copper fill-copper" data-id="element-128" />
                <span className="font-heading font-bold text-lg text-white" data-id="element-129">
                  KreanaCrochet
                </span>
              </div>
              <p className="text-xs text-white/40" data-id="element-130">
                Tejiendo recuerdos, una puntada a la vez.
              </p>
            </div>

            <div className="flex gap-6 text-xs font-medium text-white/50" data-id="element-131">
              <a href="#" className="hover:text-white transition-colors" data-id="element-132">
                Términos
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-133">
                Privacidad
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-134">
                Contacto
              </a>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-white/10 text-center text-xs text-white/30" data-id="element-135">
            © {new Date().getFullYear()} KreanaCrochet. Todos los derechos
            reservados.
          </div>
        </div>
      </div>
    </footer>;
}